<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap" style="display: flex;flex-wrap: wrap">
        <div></div>
        <a-button type="primary" @click="addWebsiteGoodsSeries">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        ref="dragTable"
        :scroll="{ y: 'calc(100vh - 345px)' }"
        childrenColumnName="[]"
        row-key="id"
        :data-source="table.data"
        :columns ="table.columns">
        <span slot="img" slot-scope="text, record" >
           <a-avatar :size="80" shape="square"  :src="record.coverPath"/>
          </span>
        <template slot="sort">
          <a-icon type="drag"  style="font-size: 25px;"/>
        </template>
        <template slot-scope="text, record" slot="action">
          <a-button type="link" @click="detailWebsiteGoodsSeries(record.id)">详情</a-button>
          <a-button type="link" @click="inspirationGoodsSeries(record.id)">{{ $t('INSPIRATION') || '灵感' }}</a-button>
          <a-button type="link" @click="editWebsiteGoodsSeries(record.id)">{{ $t('EDIT') || '编辑' }}</a-button>
          <a-button type="link" @click="deleteWebsiteGoodsSeries(record.id)">{{ $t('DELETE') || '删除' }}
          </a-button>
        </template>
      </a-table>
    </div>
    <a-modal
      :footer="null"
        title="编辑"
        v-model="form.visible">
      <website-goods-series-edit
        v-if="form.visible"
        :goods-series-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </website-goods-series-edit>
    </a-modal>
    <a-drawer
      title="系列商品"
      placement="right"
      :closable="false"
      width="60%"
      :destroyOnClose="true"
      @close="()=>{goodsForm.visible = false}"
      :visible="goodsForm.visible"
    >
      <series-items
        v-if="goodsForm.visible"
        :series-id="goodsForm.data.id">
      </series-items>
    </a-drawer>
    <a-modal
      :footer="null"
      title="灵感"
      v-model="inspiration.visible">
      <goods-series-inspiration-edit
        v-if="inspiration.visible"
        :series-id="inspiration.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </goods-series-inspiration-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryWebsiteGoodsSeries,
  _deleteGoodsSeries,
  _updateGoodsSort,
} from '@/api/websiteGoodsSeriesApi';
import WebsiteGoodsSeriesEdit from './SeriesEdit.vue';
import SeriesItems from './SeriesItems.vue';
import Sortable from 'sortablejs';
import GoodsSeriesInspirationEdit from './GoodsSeriesInspirationEdit.vue';

async function getWebsiteGoodsSeriesList() {
  // let direction = this.table.sort.order;
  // if (direction) {
  //   direction = direction === 'ascend' ? 'ASC' : 'DESC';
  // }
  const direction = 'ASC';
  const result = await _queryWebsiteGoodsSeries({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  const list = result.content;
  this.table.data = list;
}

function addWebsiteGoodsSeries() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editWebsiteGoodsSeries(goodsSeriesId) {
  this.form.data.id = goodsSeriesId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getWebsiteGoodsSeriesList();
}

function inspirationGoodsSeries(goodsSeriesId) {
  this.$router.push(`/goods-series-inspiration/${goodsSeriesId}`);
}

async function deleteWebsiteGoodsSeries(goodsSeriesId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      await _deleteGoodsSeries(goodsSeriesId);
      this.$message.success('删除成功');
      await this.getWebsiteGoodsSeriesList();
    },
  });
}

function detailWebsiteGoodsSeries(goodsSeriesId) {
  this.$router.push(`/goods-series-gather/${goodsSeriesId}`);
}

/**
 * table 关联 id
 */
function initSortable() {
  const el = this.$refs.dragTable.$el.querySelector('.ant-table-tbody')
  const dragTable = Sortable.create(el, {
    handle: 'td:nth-child(4)',
    animation: 150,
    // 利用更新
    onUpdate: (e) => {
      const oldIndex = e.oldIndex
      const newIndex = e.newIndex
      if (oldIndex === newIndex) {
        return
      }
      this.updateSortList(oldIndex, newIndex)
    },

  })
}

async function updateSortList(oldIndex, newIndex) {
  const idStr = this.table.data.map(x => x.id).join(',')
  const sortStr = this.table.data.map(x => x.sort).join(',')
  const result = await _updateGoodsSort({
    idStr,
    sortStr,
    oldIndex,
    newIndex
  })
  if (result) {
    this.$message.success('移动排序成功')
    await this.getWebsiteGoodsSeriesList()
  }
}

const columns = [
  {
    title: '渠道',
    dataIndex: 'channel',
    scopedSlots: { customRender: 'channel' },
  },
  {
    title: '标题',
    dataIndex: 'name',
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '图片',
    scopedSlots: { customRender: 'img' },
  },
  {
    title: '拖拽排序',
    dataIndex: 'id',
    align: 'center',
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: '操作',
    width: 300,
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'WebsiteGoodsSeriesList',
  components: {
    WebsiteGoodsSeriesEdit,
    SeriesItems,
    GoodsSeriesInspirationEdit,
  },
  data() {
    return {
      inspiration: {
        data: {
          id: null,
        },
        visible: false,
      },
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      goodsForm: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        columns: columns,
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'ASC',
        },
      },
    };
  },
  methods: {
    getWebsiteGoodsSeriesList,
    deleteWebsiteGoodsSeries,
    editWebsiteGoodsSeries,
    addWebsiteGoodsSeries,
    closeForm,
    detailWebsiteGoodsSeries,
    initSortable,
    updateSortList,
    inspirationGoodsSeries,
  },
  mounted() {
    this.initSortable();
  },
  created() {
    this.getWebsiteGoodsSeriesList();
  },
};
</script>

<style scoped>

</style>
